
/////////////////////////////////
// contest form
var _contestFormHiddenAnswerContent = "";
function initContestForm() {
	if ($(".contestForm__form").length > 0) {

		$(".contestForm__form").each(function () {

			var $submitButton = $(this).find(".submitButton");
			$submitButton.on("click", function(e){
				e.preventDefault();

				_contestFormHiddenAnswerContent = "";

				var $form = $(this).closest(".contestForm__form");
				$form.find(".contestForm__answer-checkbox").each(function(){
					if($(this).prop("checked")){
						//add comma?!
						var comma = "";
						if(_contestFormHiddenAnswerContent != ""){
							comma = ",";
						}

						//add value
						_contestFormHiddenAnswerContent += comma;
						_contestFormHiddenAnswerContent += $(this).val();
					}
				});

				var $hiddenAnswer = $form.find(".contestForm__answer-hidden");
				$hiddenAnswer.val(_contestFormHiddenAnswerContent);

				var $ffErrors = $form.find(".error");

				if($ffErrors.length > 0){
					//validation errors found
				}
				else{
					$form.submit();
				}
			});
			
			
		});
	}
}